/* Maison Velours — page produit : variantes, galerie, barre d'achat mobile */
(function () {
  'use strict';

  function formatMoney(cents) {
    var format = (window.MVSettings && window.MVSettings.moneyFormat) || '{{amount}}';
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return format.replace(/\{\{\s*amount(_with_comma_separator)?\s*\}\}/, amount);
  }

  function initProduct(root) {
    var dataEl = root.querySelector('[data-variants-json]');
    if (!dataEl) return;

    var variants = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form[data-ajax-cart]');
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-variant-price]');
    var compareEl = root.querySelector('[data-variant-compare]');
    var submit = root.querySelector('[data-add-button]');
    var buyNow = root.querySelector('[data-buy-now]');
    var stock = root.querySelector('[data-variant-stock]');
    var sku = root.querySelector('[data-variant-sku]');
    var strings = window.MVStrings || {};

    function currentOptions() {
      return Array.from(root.querySelectorAll('[data-option-index]'))
        .filter(function (input) { return input.type !== 'radio' || input.checked; })
        .sort(function (a, b) { return a.getAttribute('data-option-index') - b.getAttribute('data-option-index'); })
        .map(function (input) { return input.value; });
    }

    function matchVariant(options) {
      if (!options.length) return variants[0];
      return variants.find(function (variant) {
        return variant.options.every(function (option, index) { return option === options[index]; });
      });
    }

    function updateLabels(options) {
      root.querySelectorAll('[data-option-value-label]').forEach(function (label) {
        var index = parseInt(label.getAttribute('data-option-value-label'), 10);
        if (options[index] !== undefined) label.textContent = options[index];
      });
    }

    function update() {
      var options = currentOptions();
      updateLabels(options);
      var variant = matchVariant(options);

      if (!variant) {
        if (submit) { submit.setAttribute('disabled', 'disabled'); submit.textContent = strings.unavailable || 'Indisponible'; }
        if (buyNow) buyNow.setAttribute('disabled', 'disabled');
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.innerHTML = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (sku) sku.textContent = variant.sku || '';

      if (stock) {
        stock.classList.remove('stock--low', 'stock--out');
        var label = stock.querySelector('[data-stock-label]');
        if (!variant.available) {
          stock.classList.add('stock--out');
          if (label) label.textContent = strings.out_of_stock || 'Rupture de stock';
        } else if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
          stock.classList.add('stock--low');
          if (label) label.textContent = (strings.low_stock || 'Plus que x_count_x en stock').replace(/x_count_x|\{\{\s*count\s*\}\}/, variant.inventory_quantity);
        } else if (label) {
          label.textContent = strings.in_stock || 'En stock';
        }
      }

      if (submit) {
        if (variant.available) {
          submit.removeAttribute('disabled');
          submit.textContent = strings.add_to_cart || 'Ajouter au panier';
        } else {
          submit.setAttribute('disabled', 'disabled');
          submit.textContent = strings.sold_out || 'Épuisé';
        }
      }

      if (buyNow) {
        if (variant.available) { buyNow.removeAttribute('disabled'); }
        else { buyNow.setAttribute('disabled', 'disabled'); }
      }

      var sticky = document.querySelector('[data-sticky-price]');
      if (sticky) sticky.innerHTML = formatMoney(variant.price);

      /* Média associé à la variante */
      if (variant.featured_media_id) {
        var thumb = root.querySelector('[data-media-id="' + variant.featured_media_id + '"]');
        if (thumb) thumb.click();
      }

      /* URL sans rechargement */
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('[data-option-index]').forEach(function (input) {
      input.addEventListener('change', update);
    });

    if (form) update();

    /* Galerie */
    var mainImage = root.querySelector('[data-main-media]');
    root.querySelectorAll('[data-media-id]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-media-src');
        var alt = thumb.getAttribute('data-media-alt') || '';
        if (mainImage && src) {
          mainImage.setAttribute('src', src);
          mainImage.setAttribute('srcset', thumb.getAttribute('data-media-srcset') || '');
          mainImage.setAttribute('alt', alt);
        }
        root.querySelectorAll('[data-media-id]').forEach(function (other) { other.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  function initSticky() {
    var bar = document.querySelector('.sticky-atc');
    var anchor = document.querySelector('[data-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    observer.observe(anchor);

    bar.querySelectorAll('[data-sticky-add]').forEach(function (button) {
      button.addEventListener('click', function () {
        var form = document.querySelector('form[data-ajax-cart]');
        if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-product-root]').forEach(initProduct);
    initSticky();
  }

  boot();
  document.addEventListener('shopify:section:load', boot);
})();
